import { useEffect,useState } from "react";

export const GoogleForms = () => {

  const [showMessage, setShowMessage] = useState(false);

    useEffect(() => {
        document.title = "ARTHUR GOOGLE FORM APPLICATION (AGFA)";

        const timer = setTimeout(() => {
            setShowMessage(true);
        }, 3000);

        return () => clearTimeout(timer);

      }, []);

  return (
    <div>
      {showMessage && (
      <center><a href="https://docs.google.com/forms/d/e/1FAIpQLSeuFO26OldpsqWFAjeQI5kypFHqouo4EOIvgxF4hqc4y383fw/viewform" target="_blank" rel="noreferrer">
        <strong>not understanding form language or displaying? click here</strong>  
      </a></center>
      )}
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSeuFO26OldpsqWFAjeQI5kypFHqouo4EOIvgxF4hqc4y383fw/viewform?embedded=true"
       width="100%" 
       height="3154" 
       frameborder="0" 
       marginheight="0" 
       marginwidth="0"
       title="ARTHUR GOOGLE FORM APPLICATION (AGFA)"
       >Loading…</iframe>
    </div>
  );
}